'use client';

import { usePathname } from "next/navigation";
import Image from "next/image";
import styles from "./Header.module.css";

/**
 * Header Component
 * ----------------
 * Displays the main header for the FishEye application.
 * - Always shows the site logo.
 * - Optionally shows navigation content (only on the homepage).
 */
export default function Header() {
  // Get the current pathname (e.g., "/", "/photographer/123")
  const pathname = usePathname();

  // Check if the current page is a photographer profile page
  const isPhotographerPage = pathname?.startsWith("/photographer/");

  return (
    <header className={styles.header}>
      {/* Application logo */}
      <Image
        src="/assets/logo.png"
        width={200}
        height={50}
        alt="Logo de FishEye"
      />

      {/* Shown only on the homepage, not on photographer pages */}
      {!isPhotographerPage && (
        <div>
          {/* Header title linking to the list of photographers */}
          <h1 className={styles.headerTitle}>
            Nos photographes
          </h1>
        </div>
      )}
    </header>
  );
}
